module.exports = __webpack_public_path__ + "static/media/RMC-hero.f8a55ee5.jpg";